import { SVGProps } from 'react';

const Instagram = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M14.25 12a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Zm1.5-4.49V7.5a.75.75 0 0 1 1.5 0v.01a.75.75 0 0 1-1.5 0Zm0 4.49a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
    />
    <path
      fill={fill}
      d="M19.25 12c0-1.412 0-2.427-.065-3.223-.065-.787-.188-1.295-.398-1.707a4.25 4.25 0 0 0-1.857-1.857c-.412-.21-.92-.333-1.707-.398-.796-.065-1.81-.065-3.223-.065-1.412 0-2.427 0-3.223.065-.787.065-1.295.188-1.707.398A4.25 4.25 0 0 0 5.213 7.07c-.21.412-.333.92-.398 1.707-.065.796-.065 1.81-.065 3.223 0 1.412 0 2.427.065 3.223.065.787.188 1.295.398 1.707a4.25 4.25 0 0 0 1.857 1.857c.412.21.92.333 1.707.398.796.065 1.81.065 3.223.065 1.412 0 2.427 0 3.223-.065.787-.065 1.295-.188 1.707-.398a4.251 4.251 0 0 0 1.857-1.857c.21-.412.333-.92.398-1.707.065-.796.065-1.81.065-3.223Zm1.5 0c0 1.387 0 2.473-.07 3.345-.072.88-.222 1.607-.557 2.265a5.749 5.749 0 0 1-2.513 2.513c-.658.335-1.385.485-2.265.557-.872.07-1.957.07-3.345.07-1.387 0-2.473 0-3.345-.07-.88-.072-1.607-.222-2.265-.557a5.749 5.749 0 0 1-2.513-2.513c-.335-.658-.485-1.385-.557-2.265-.07-.872-.07-1.957-.07-3.345 0-1.388 0-2.473.07-3.345.072-.88.222-1.607.557-2.265A5.75 5.75 0 0 1 6.39 3.877c.658-.335 1.385-.485 2.265-.557.872-.07 1.958-.07 3.345-.07 1.388 0 2.473 0 3.345.07.88.072 1.607.222 2.265.557a5.75 5.75 0 0 1 2.513 2.513c.335.658.485 1.385.557 2.265.07.872.07 1.957.07 3.345Z"
    />
  </svg>
);

export default Instagram;
